export default __webpack_public_path__ + "static/parigi-plus-lite-2-e190dc41d52eb8e59664ad33bfdcdc98.jpg";